<ion-content class="ion-padding">
  <div [formGroup]="myForm">
    <ion-item>
      <ion-label position="stacked">Nombre del pozo</ion-label>
      <ion-input
        formControlName="name"
        placeholder="Nombre del pozo"></ion-input>
    </ion-item>
  </div>
</ion-content>
